import trainingsTemplate from '@/store/modules/trainings-template/trainings-template'
import trainingTemplateCreate from '@/store/modules/trainings-template/training-template-create'
import trainingTemplateEdit from '@/store/modules/trainings-template/training-template-edit'
import trainingTemplateDelete from '@/store/modules/trainings-template/training-template-delete'

export default {
  trainingsTemplate,
  trainingTemplateCreate,
  trainingTemplateEdit,
  trainingTemplateDelete
}
